import type { EntitySet, SearchResultSet } from 'owa-search-service';

export default function getSearchResultSetFromEntitySet(entitySet: EntitySet): SearchResultSet {
    if (entitySet?.ResultSets?.[0]) {
        return entitySet.ResultSets[0];
    }

    return null;
}
